export const AccountSelectorContainer = ({ children }: { children: any }) => {
  return (
    <div className="w-full container-lg">
      <ul className="border-b divide-y divide-gray-light border-gray-light">{children}</ul>
    </div>
  );
};

const AccountSelectorItem = ({
  forwardRef,
  children,
  onClick,
}: {
  forwardRef?: any;
  children: any;
  onClick: (acc: any) => void;
}) => {
  return (
    <li>
      <button
        className="flex items-center w-full gap-16 px-0 py-16 text-left transition-colors duration-150 sm:px-16 sm:mx-0 hover:bg-teal-lighter"
        ref={forwardRef}
        onClick={onClick}
      >
        <div className="flex-grow">{children}</div>
        <div className="flex-shrink-0">
          <svg
            className="icon-18 text-teal-darker"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            fill="currentColor"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M49.092,30.027l-1.034-1.034h0L19.977,.819c-1.088-1.09-2.854-1.092-3.944-.004,0,0,0,0,0,0v.004l-1.038,1.033c-1.089,1.089-1.089,2.855,0,3.944v.005l26.102,26.2L14.99,58.2c-1.089,1.089-1.089,2.855,0,3.945v.004l1.034,1.034c1.089,1.089,2.855,1.089,3.944,0,0,0,0,0,0,0h.004l28.006-28.048h0l1.033-1.034c1.085-1.099,1.085-2.865,0-3.964l.079-.109Z"></path>
          </svg>
        </div>
      </button>
    </li>
  );
};

export const AccountSelector = {
  Container: AccountSelectorContainer,

  Item: AccountSelectorItem,
};
